// 用户分析 — M8 已切真后端（user_metrics + user_source 表）
// 6 维度画像（gender/age/region/device/model/language）暂时空 — 对应 scraper 还没写
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export interface UserKPI {
  cumulate: number
  newUser: number
  cancelUser: number
  netUser: number
}

export interface UserAttrs {
  gender: { name: string; value: number }[]
  age: { name: string; value: number }[]
  region: { name: string; value: number }[]
  device: { name: string; value: number }[]
  model: { name: string; value: number }[]
  language: { name: string; value: number }[]
}

export interface UserSource {
  name: string
  value: number
}

export interface FollowerRankItem {
  name: string
  value: number
}

export interface UserAnalysisData {
  kpi: UserKPI
  fanTrend30d: { date: string; value: number }[]
  attrs: UserAttrs
  source: UserSource[]
  rankRead: FollowerRankItem[]
  rankShare: FollowerRankItem[]
  rankComment: FollowerRankItem[]
}

export function useUserAnalysis() {
  return useQuery({
    queryKey: ['users', 'analysis'],
    queryFn: () => get<UserAnalysisData>('/users/analysis'),
  })
}
